import { Menu, MenuButton, MenuItems } from "@headlessui/react";
export default function DropdownLayoutV2({ activator, children }) {
  return (
    <Menu as="div" className="relative inline-block w-full">
      <>
        <MenuButton className="inline-flex items-center space-x-2 text-sm text-blue-900 w-full">
          {activator}
        </MenuButton>
      </>

      <MenuItems className="w-full rounded-sm absolute left-0 z-20 mt-2 origin-top-left bg-white ring-opacity-5 transition focus:outline-hidden data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-leave:duration-75 data-enter:ease-out data-leave:ease-in">
        <>{children}</>
      </MenuItems>
    </Menu>
  );
}
